import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import { Link } from "react-router-dom";
import  './../../utils/analytics';


export default class extends Component {
  render() {
    return (
		<div className="light-grey-background">
      <Hero
        title={'Your Message Has Been Sent'}
        description={'Someone will be contacting you shortly to talk about next steps.'}
        backgroundImage={'images/thankyou-hero.jpg'}
        link={'/'}
        linkText={'Continue'}
        height={'full'} /*full, half,threequarter*/
        subtitlePosition={'bottom'}
        tint={'dark'}
      />
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/thankyou/index.js